import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 43.86" {...this.props}><title>location-active-warning</title><path fill="currentColor" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" d="M1 29.5v-22L7.5 1H29v28.5l-14 13-14-13z" /><path fill="#fff" d="M13.95 11h3v10h-3zm0 12h3v3h-3z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/location-active-warning.inline.svg